import { CameraSwitchIcon } from '@rsos/assets/icons';
import { useDispatcherVideoContext } from '../../DispatcherVideoContext/useDispatcherVideoContext';
import { StyledButton } from './DispatcherControls.styles';

export const FlipCameraButton = () => {
  const { caller, toggleCallerFacingMode } = useDispatcherVideoContext();

  return (
    <StyledButton
      title="Flip camera"
      onClick={toggleCallerFacingMode}
      disabled={!caller}
    >
      <CameraSwitchIcon />
    </StyledButton>
  );
};
